import { render, staticRenderFns } from "./AdministratorImageRow.vue?vue&type=template&id=28962884&"
import script from "./AdministratorImageRow.vue?vue&type=script&lang=ts&"
export * from "./AdministratorImageRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports